import React, { memo } from 'react';
import {
  IRapportUtdelning,
  IGrundurval,
} from '../../Queries/AnalysutdelningQuery/AnalysutdelningQuery';
import { Theme } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import {
  ChangeVisibilityFnType,
  SetStartAnalysFnType,
  ChangeUrvalFnType,
  SetAvailableFnType,
} from '../AnalysUtdelningMain/AnalysUtdelningMain';
import AnalysUtdelningTable from '../AnalysUtdelningTable/AnalysUtdelningTable';

interface IProps {
  analyser: IRapportUtdelning[];
  setStartAnalys: SetStartAnalysFnType;
  changeUrval: ChangeUrvalFnType;
  changeVisibility: ChangeVisibilityFnType;
  urvalOptions: IGrundurval[];
  setAvailable: SetAvailableFnType;
  classes?: any;
}

const styles = (theme: Theme) => ({
  container: {
    overflowY: 'auto',
  },
});

/**
 * Komponent för att visa upp en lista av utdelade analyser med möjlighet att ändra inställningar för dem
 */
export const AnalysUtdelningAnalysList: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    analyser,
    changeUrval,
    setStartAnalys,
    changeVisibility,
    urvalOptions,
    setAvailable,
  } = props;

  return (
    <div className={props.classes.container}>
      <AnalysUtdelningTable
        changeUrval={changeUrval}
        setStartAnalys={setStartAnalys}
        changeVisibility={changeVisibility}
        analyser={analyser}
        urvalOptions={urvalOptions}
        setAvailable={setAvailable}
      />
    </div>
  );
};

export default withStyles(memo(AnalysUtdelningAnalysList), styles);
